"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../../components/theme");
exports.CSS = {
    container: 'c-FormEditField',
    isSelected: 'c-FormEditField--is-selected',
    title: 'c-FormEditField__title',
    isInvalid: 'c-FormEditField__title--invalid',
    label: {
        container: 'c-FormEditField__label',
        icon: 'c-FormEditField__labelIcon',
        text: 'c-FormEditField__labelText'
    },
    tag: {
        list: 'c-FormEditField__tags',
        tag: 'c-FormEditField__tag',
        cloneable: 'c-FormEditField__tag--cloneable',
        label: 'c-FormEditField__tag--label',
        status: 'c-FormEditField__tag--status'
    },
    form: {
        container: 'c-FormEditForm',
        children: 'c-FormEditForm__children'
    }
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        'align-items': 'center',
        ['& button']: {
            'border-left': '2px solid transparent'
        }
    },
    [`${exports.CSS.isSelected} .${exports.CSS.title}`]: {
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'border-left': `2px solid ${theme_1.DefaultTheme.color.accent}`
    },
    [exports.CSS.tag.list]: {
        display: 'flex'
    },
    [exports.CSS.tag.tag]: {
        'font-weight': 'bold',
        'font-size': '12px',
        'margin-left': '4px',
        'border-radius': '50%',
        'line-height': '16px',
        height: '16px',
        width: '16px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        border: '1px solid ' + theme_1.DefaultTheme.background.grey,
        'background-color': theme_1.DefaultTheme.background.lightGrey
    },
    [exports.CSS.tag.label]: {
        'border-radius': '50%',
        padding: 0
    },
    [exports.CSS.title]: {
        width: '100%',
        display: 'flex',
        'justify-content': 'space-between',
        'align-items': 'center',
        'padding-left': 0
    },
    [exports.CSS.isInvalid]: {
        [`& .${exports.CSS.label.container}`]: {
            color: theme_1.DefaultTheme.font.color.error
        }
    },
    [exports.CSS.label.container]: {
        color: theme_1.DefaultTheme.font.color.primary,
        display: 'flex',
        'align-items': 'center',
        overflow: 'hidden'
    },
    [exports.CSS.label.icon]: {
        padding: theme_1.DefaultTheme.space(1),
        'text-align': 'center',
        'font-size': '18px',
        width: '18px',
        height: '18px'
    },
    [exports.CSS.label.text]: {
        display: 'block',
        'text-align': 'left',
        overflow: 'hidden',
        'white-space': 'nowrap',
        'text-overflow': 'ellipsis',
        'text-transform': 'none'
    },
    [exports.CSS.form.children]: {
        'margin-left': theme_1.DefaultTheme.space(5)
    }
};
//# sourceMappingURL=form.field.tree.view.style.js.map